export default function CComments() {
  return <h2>C Comments</h2>;
}
